var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import styled from 'styled-components';
import THEME from '../theme';
const ButtonGroup = (props) => {
    const { children } = props, other = __rest(props, ["children"]);
    return React.createElement(ButtonGroupStyled, Object.assign({}, other), children);
};
export default ButtonGroup;
const ButtonGroupStyled = styled.div `
  display: inline-block;
  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.1);

  .btn {
    border-radius: 0;
    box-shadow: inset 1px 0px 0px 0px rgba(0, 0, 0, 0.2);

    &:first-child {
      box-shadow: none;
      border-top-left-radius: 3px;
      border-bottom-left-radius: 3px;
    }

    &:last-child {
      border-top-right-radius: 3px;
      border-bottom-right-radius: 3px;
    }
  }

  @media ${THEME.MEDIA_QUERY_MOBILE} {
    ${(props) => props.blockOnMobile
    ? `
      display: block;
      width: 100%;
      `
    : ''}
  }
`;
//# sourceMappingURL=ButtonGroup.js.map